
import { Component, Watch, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { MediaService } from '@/services/index'
import { parseTime } from '@/common/utils'

@Component({
    name: 'AddExp',
    components: {
    }
})
export default class extends Vue {
    private validateEndRange = (rule: any, value: string, callback: Function) => {
        if (!value || value.length === 0) {
            callback(new Error('请选择在职时间'))
        } else {
            callback()
        }
    }
    private expRules = {
        mediaName: [
            { required: true, message: '请输入单位名', trigger: 'blur' },
            { min: 1, max: 15, message: '请输入正确的单位名，1-15个字符', trigger: 'blur' }
        ],
        startDate: [
            { required: true, message: '请选择在职时间', trigger: 'blur' }
        ],
        endDate: [
            { validator: this.validateEndRange, trigger: 'blur' }
        ],
        position: [
            { required: true, message: '请输入职位名称', trigger: 'blur' },
            { min: 2, max: 10, message: '请输入正确的职位名称，2-10个字符', trigger: 'blur' }
        ],
        content: [
            { min: 0, max: 300, message: '请输入正确的经历亮点，0-300个字符', trigger: 'blur' }
        ]
    }
    private isVisible: boolean = false
    private expForm: any = {
        mediaName: '',
        media: {
            id: '',
            name: ''
        },
        position: '',
        content: '',
        startDate: '',
        endDate: ''
    }
    private endDateOptions = {}
    private addExpCbFunc: any = null
    private isEdit: boolean = false

    @Watch('expForm.startDate')
    onStartDateChange() {
        this.endDateOptions = this.endDateOptionsFunc()
    }

    private mounted() {
        this.endDateOptions = this.endDateOptionsFunc()
    }

    private endDateOptionsFunc() {
        const that = this
        return {
            disabledDate(time: any) {
                if (that.expForm.startDate) {
                    return time.getTime() < that.expForm.startDate.getTime() || 
                        time.getTime() > Date.now()
                } else {
                    return time.getTime() > Date.now()
                }
            },
            shortcuts: [{
                text: '至今',
                onClick(vm: any) {
                    vm.$emit('pick', '至今')
                    that.$nextTick(() => {
                        that.getEndDateInput().value = '至今'
                    })
                }
            }]
        }
    }

    private getEndDateInput() {
        return document.querySelector('.ipt-end-date .el-input__inner') as any
    }

    private getExpForm() {
        return this.$refs.expForm as ElForm
    }

    private hide() {
        this.expForm = {
            mediaName: '',
            media: {
                id: '',
                name: ''
            },
            position: '',
            content: '',
            startDate: '',
            endDate: ''
        }
        this.isVisible = false
        this.getEndDateInput().value = ''
        this.getExpForm().resetFields()
    }

    private show(exp: any, callback: Function) {
        if (exp) {
            this.isEdit = true
            this.expForm = {
                id: exp.id, 
                mediaName: exp.media.name,
                media: exp.media,
                position: exp.position,
                content: exp.content,
                startDate: new Date(exp.start_at),
                endDate: exp.end_at ? new Date(exp.end_at) : '至今'
            }
        } else {
            this.isEdit = false
        }
        this.isVisible = true
        this.addExpCbFunc = callback
        this.$nextTick(() => {
            if (this.isEdit && exp.end_at === '') {
                this.getEndDateInput().value = '至今'
            }
        })
    }

    private async getMedias(queryString: string, cb: Function) {
        if (queryString) {
            const result = await MediaService.searchMedia({ value: queryString })
            if (result.status === 200) {
                const medias = result.data.map((
                    media: { id: number, name: string }
                ) => {
                    return {
                        id: media.id,
                        value: media.name
                    }
                })
                cb(medias)
            }
        } else {
            cb([])
        }
    }

    private getEndDate() {
        if (this.expForm.endDate === '至今') return '' 
        return parseTime(this.expForm.endDate, '{y}-{m}-{d}')
    }

    private onSelectMedia(media: any) {
        this.expForm.media = { id: media.id, name: media.value }
    }

    private onAdd() {
        this.getExpForm().validate(async(valid: boolean) => {
            if (valid) {
                const media = this.expForm.media
                const endDate = this.getEndDate()
                let exp = {
                    media: media.name && media.name === this.expForm.mediaName 
                        ? media : { id: '', name: this.expForm.mediaName },
                    position: this.expForm.position,
                    content: this.expForm.content,
                    start_at: parseTime(this.expForm.startDate, '{y}-{m}-{d}'),
                    end_at: endDate
                }
                if (this.isEdit) {
                    exp = Object.assign(exp, { id: this.expForm.id })
                }
                this.addExpCbFunc(exp)
                this.hide()
            } else {
                return false
            }
        })
    }
}
